import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bbb6a56e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "has-background-footer the-global-footer" }
const _hoisted_2 = { class: "the-global-footer-inner" }
const _hoisted_3 = { class: "level level-left the-global-footer-navi" }
const _hoisted_4 = {
  class: "has-text-footer has-text-contents-normal",
  href: "https://www.ndl.go.jp/"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "has-text-contents-normal has-text-footer level-right the-global-footer-copy" }, " Copyright © 2011- National Diet Library. All Rights Reserved. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$t('footer.title')), 1)
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            class: "has-text-footer has-text-contents-normal",
            to: { name: 'Sitepolicy' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isRekion ? _ctx.$t('footer.sitePolicy') : _ctx.$t('footer.termsOfUse')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            class: "has-text-footer has-text-contents-normal",
            to: { name: 'Contact' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('footer.inquiry')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_5
    ])
  ]))
}